import Loadable from '../../components/loadable';

const ManageDuplicateRecipientsModal = Loadable({
  loader: () => import('../../pages/messages/manage_duplicate_recipients_modal'),
  type: 'drawer',
});

angular.module('shared').value('ManageDuplicateRecipientsModal', ManageDuplicateRecipientsModal);
